/* eslint-disable no-unused-vars */
import React, { useContext } from 'react';
import Grid from '@mui/material/Unstable_Grid2';
import { DataGridPro } from '@mui/x-data-grid-pro';
import { Box, Button } from '@mui/material';
import useReportContext from '../context/useReportContext';

function MTDSummaryTable() {
  const { reportData, exportMTDSummary } = useContext(useReportContext);

  const handlePerfCellClassName = (value) => {
    let className;

    if (parseFloat(value) >= 100) {
      className = 'cell-green';
    }

    if (parseFloat(value) >= 85 && parseFloat(value) <= 99) {
      className = 'cell-yellow';
    }

    if (parseFloat(value) >= 1 && parseFloat(value) <= 84) {
      className = 'cell-red';
    }

    if (parseFloat(value) < 1) {
      className = 'cell-super-red';
    }

    return className;
  };

  const columns = [
    {
      field: 'md_count',
      headerName: 'MD Count',
      width: 200,
      flex: 1,
      cellClassName: ({ row }) => `cell-row-${row.id}`,
      headerClassName: 'super-app-theme--header',
    },
    {
      field: 'target',
      headerName: 'Target',
      width: 200,
      flex: 1,
      cellClassName: ({ row }) => `cell-row-${row.id}`,
      headerClassName: 'super-app-theme--header',
    },
    {
      field: 'completed',
      headerName: 'Completed',
      width: 200,
      flex: 1,
      cellClassName: ({ row }) => `cell-row-${row.id}`,
      headerClassName: 'super-app-theme--header',
    },
    {
      field: 'vmc',
      headerName: 'VMC',
      width: 200,
      flex: 1,
      cellClassName: ({ row }) => `cell-row-${row.id}`,
      headerClassName: 'super-app-theme--header',
    },
    {
      field: 'call_perf',
      headerName: 'Call Performance %',
      width: 150,
      flex: 1,
      headerClassName: 'super-app-theme--header',
      cellClassName: ({ row }) => handlePerfCellClassName(row.call_perf),
      renderCell: ({ row }) => `${parseFloat(row.call_perf).toFixed(2)}%`,
    },
    {
      field: 'completed_vmc',
      headerName: 'Completed + VMC %',
      width: 150,
      flex: 1,
      headerClassName: 'super-app-theme--header',
      cellClassName: ({ row }) => handlePerfCellClassName(row.completed_vmc),
      renderCell: ({ row }) => `${parseFloat(row.completed_vmc).toFixed(2)}%`,
    },
    {
      field: 'reach',
      headerName: 'Call Reach %',
      width: 150,
      flex: 1,
      headerClassName: 'super-app-theme--header',
      cellClassName: ({ row }) => handlePerfCellClassName(row.reach),
      renderCell: ({ row }) => `${parseFloat(row.reach).toFixed(2)}%`,
    },
    {
      field: 'concentration',
      headerName: 'Call Concentration %',
      width: 150,
      flex: 1,
      headerClassName: 'super-app-theme--header',
      cellClassName: ({ row }) => handlePerfCellClassName(row.concentration),
      renderCell: ({ row }) => `${parseFloat(row.concentration).toFixed(2)}%`,
    },
  ];
  const getTreeDataPath = (row) => row.hierarchy;
  const groupingColDef = {
    headerName: ' ',
    field: 'hierarchy',
    width: 300,
  };

  const pinnedRows = {
    top: reportData.mtd_data.length ? [reportData.mtd_data[0]] : [],
  };

  return (
    <Grid container spacing={2}>
      <Grid xs={12} sm={12} md={12}>
        <Box sx={{ display: 'flex', justifyContent: 'flex-end' }}>
          <Button
            variant='contained'
            color='success'
            onClick={exportMTDSummary}
            sx={{
              marginLeft: '20px',
              marginBottom: '20px',
              paddingTop: '10px',
            }}
          >
            Export MTD Summary
          </Button>
        </Box>
        <Box
          className='table-container'
          sx={{
            height: '800px',
            marginLeft: '20px',
            '& .cell-green': {
              backgroundColor: '#5cb85c',
              color: '#000',
              fontWeight: '600',
            },
            '& .cell-yellow': {
              backgroundColor: '#f0ad4e',
              color: '#000',
              fontWeight: '600',
            },
            '& .cell-red': {
              backgroundColor: '#FFADB0',
              color: '#000',
              fontWeight: '600',
            },
            '& .cell-super-red': {
              backgroundColor: '#d9534f',
              color: '#000',
              fontWeight: '600',
            },
            '& .super-app-theme--header': {
              backgroundColor: '#169016',
              color: '#fff',
              fontWeight: 'bold',
            },
            '& .Mui-selected': {
              color: '#000',
              fontWeight: '600',
            },
            '& .MuiDataGrid-pinnedRows': { fontWeight: 'bold', backgroundColor: '#cdf8cd' },
          }}
        >
          <DataGridPro
            treeData
            loading={reportData.mtd_loading}
            rows={reportData.mtd_data}
            columns={columns}
            getTreeDataPath={getTreeDataPath}
            groupingColDef={groupingColDef}
            pinnedRows={pinnedRows}
            experimentalFeatures={{ rowPinning: true }}
          />
        </Box>
      </Grid>
    </Grid>
  );
}

export default MTDSummaryTable;
